import { Avatar, Group, Paper, Skeleton, Stack, Text } from '@mantine/core';
import { useHover } from '@mantine/hooks';
// import Badge from 'components/Badge';
import React from 'react';

interface FacilitatorItemProps {
  loading?: boolean;
  name?: string;
  email?: string;
  approvalLevel?: number;
  binusianId?: string;
  onClick?: () => void;
}

const FacilitatorItem: React.FC<FacilitatorItemProps> = ({
  loading = false,
  approvalLevel,
  binusianId,
  onClick,
  email,
  name
}) => {
  const { hovered, ref } = useHover();
  if (loading) {
    return (
      <Paper withBorder w={200} p={10}>
        <Group align='flex-start' gap={10} w={'100%'}>
          <Skeleton w={40} h={40} radius={'100%'} />
          <Stack gap={4} flex={1}>
            <Skeleton w={'50%'} h={14} />
            <Skeleton w={'80%'} h={14} />
            <Skeleton w={'30%'} h={14} />
          </Stack>
        </Group>
      </Paper>
    );
  }
  return (
    <Group
      ref={ref}
      style={
        onClick && {
          cursor: 'pointer',
          border: '1px solid #E5E5E5',
          borderRadius: 8,
          padding: 8
        }
      }
      bg={hovered && onClick ? 'gray.1' : 'white'}
      onClick={onClick}
      align='flex-start'
      gap={10}
    >
      <Avatar size={40} />
      <Stack gap={0}>
        <Text fw={'bold'}>{name || binusianId}</Text>
        <Text fz={'sm'}>{email}</Text>
        <Text fz={'sm'}>Approval Level {approvalLevel}</Text>
        {/* <Badge variant='success'>Approved</Badge> */}
      </Stack>
    </Group>
  );
};

export default FacilitatorItem;
